import React, { useState, useEffect } from "react";
import "./WeatherForecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
    const [loaded, setLoaded] = useState(false);
    const [forecast, setForecast] = useState(null);

    useEffect(() => {
    setLoaded(false);
    }, [props.coordinates]);


function handleResponse(response) {
setForecast(response.data.daily);
setLoaded(true);
}

if(loaded) {
    return (
    <div className="WeatherForecast">
    <div className="row">
       <div className="col">
       <WeatherForecastDay data={forecast[1]} unit={props.unit} />
           </div>
           <div className="col">
       <WeatherForecastDay data={forecast[2]} unit={props.unit} />
           </div>
           <div className="col">
       <WeatherForecastDay data={forecast[3]} unit={props.unit} />
           </div>
           <div className="col">
       <WeatherForecastDay data={forecast[4]} unit={props.unit} />
           </div>
           <div className="col">
       <WeatherForecastDay data={forecast[5]} unit={props.unit} />
           </div>
         </div>
        </div>
    );

} else {

let longitude = props.coordinates.lon;
let latitude = props.coordinates.lat;
let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=60ad999468395538cd607575dc0c5650&units=metric`;

axios.get(apiUrl).then(handleResponse);
return null;      
}
}